import { useMemo } from 'react';

import blogPostCollectionQuery from '@glass/shared/modules/content/queries/blogPostCollection.graphql';
import useContentfulQuery from '@glass/shared/modules/content/useContentfulQuery';

const useBlogResources = ({ limit, skip, ssr = false }) => {
  const options = useMemo(
    () => ({
      variables: {
        limit,
        tagLimit: 5,
        order: ['updatedAt_DESC', 'publishedAt_DESC'],
      },
      ssr,
      skip,
    }),
    [ssr, limit, skip],
  );

  const queryData = useContentfulQuery(blogPostCollectionQuery, options);

  return useMemo(
    () => ({
      ...queryData,
      posts: queryData?.data?.blogPostCollection?.items,
    }),
    [queryData],
  );
};

export default useBlogResources;
